module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.8207/img/storefront-header-blobs.svg"